/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { useNavigate } from 'react-router-dom';

import { GuardedButton } from '@/components/GuardedButton';
import { PageHeader } from '@/components/PageHeader';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Container } from '@/primitives/Container';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';
import './APITokensHeader.css';

const { useBreakpoint } = Grid;

export function APITokensHeader() {
  const { t } = useMimicTranslation('apiTokens');
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const tenantID = useMgmtPlaneStateStore((state) => state.selectedTenantID);

  const navigateToCreateToken = () => {
    navigate(`/tenants/${tenantID}/api-tokens/new`);
  };

  const buttonHeight = screens.sm ? undefined : '45px';
  const buttonWidth = screens.sm ? undefined : '170px';

  return (
    <div className="api-tokens-header">
      <PageHeader title={t('listTitle')} level={2} />
      <Container horizontal gap="sm">
        <GuardedButton
          requiredRole="admin"
          type="primary"
          dataTestId="create-api-token"
          onClick={navigateToCreateToken}
          style={{ height: buttonHeight, width: buttonWidth }}
        >
          <PlusOutlined /> {t('newAPIToken')}
        </GuardedButton>
      </Container>
    </div>
  );
}
